var render, staticRenderFns
import script from "./lemon-message-transfer.vue?vue&type=script&lang=js"
export * from "./lemon-message-transfer.vue?vue&type=script&lang=js"
import style0 from "./lemon-message-transfer.vue?vue&type=style&index=0&id=1b46bad0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b46bad0",
  null
  
)

export default component.exports